import React, { useEffect } from 'react'
import { Col, Form, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form'
import CustomButton from '../shared/CustomButton';
import CustomSelect from './../form_components/CustomSelect';
import { FaSave } from 'react-icons/fa';

const UserForm = ({
    user,
    isSaving,
    formAction
}) => {
    const {
        register,
        handleSubmit,
        reset,
        formState: {errors},
        setError,
        control
    } = useForm({
        defaultValues: user ? {
            id: user.id,
            name: user.name,
            username: user.username,
            email: user.email,
            phone: user.phone,
            role: {
                label: user.role,
                value: user.role
            }
        } : {}
    });

    const resetForm = () => {
        reset({
            id: '',
            name: '',
            email: '',
            username: '',
            phone: '',
            role: ''
        });
    }

    useEffect(() => {
        if (user){
            console.log(user.role);
            reset({
                id: user.id,
                name: user.name,
                username: user.username,
                email: user.email,
                phone: user.phone,
                role: {
                    label: user.role,
                    value: user.role
                }
            });
        } else {
            reset({
                id: '',
                name: '',
                email: '',
                username: '',
                phone: '',
                role: ''
            });
        }
    }, [reset, user]);

    const onSubmit = async (data) => {
        try {
            const success = await formAction(data);
            if (success){
                resetForm();
            }
        } catch(error){
            if (error.response && error.response.status === 422){
                Object.keys(error.response.data.errors).forEach((field) => {
                    setError(field, {
                        type: 'manual',
                        message: error.response.data.errors[field][0]
                    });
                });
            } else {
                throw error; // error will be handled in saveUser() in Users.jsx
            }
        }
    }
  return (
    <Form onSubmit={handleSubmit(onSubmit)}>

        <Row>

            <Col xl={3} lg={4} md={6} sm={12}>

                <Form.Group>

                    <Form.Label htmlFor='name'>Name</Form.Label>
                    <input type='text' autoFocus autoComplete='off' placeholder='Name'
                        className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                        {...register('name', {
                            required: 'Enter user\'s name',
                            minLength: {
                                value: 5,
                                message: 'User\'s name must have at least 5 characters'
                            },
                            maxLength: {
                                value: 100,
                                message: 'User\'s name must not have more than 100 characters'
                            },
                            pattern: {
                                value: /^[a-zA-Z\s'-]+$/,
                                message: 'Name must contain letters and spaces only',
                            },
                        })}
                    />
                    {errors.name && (
                        <div className="invalid-feedback">{errors.name.message}</div>
                    )}

                </Form.Group>
            
            </Col>

            <Col xl={3} lg={4} md={6} sm={12}>
                    
                <Form.Group>

                    <Form.Label htmlFor='email'>Email Address</Form.Label>
                    <input type='email' autoComplete='off' placeholder='Email Address'
                        className={`form-control ${errors.email ? 'is-invalid' : '' }`}
                        {...register('email', {
                            required: 'Enter user\'s email address',
                            pattern: {
                                value: /^[A-z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                message: 'Email address is not valid'
                            }
                        })}
                    />
                    {errors.email && (
                        <div className="invalid-feedback">{errors.email.message}</div>
                    )}

                </Form.Group>

            </Col>

            <Col xl={3} lg={4} md={6} sm={12}>

                <Form.Group>

                    <Form.Label htmlFor='username'>Username</Form.Label>
                    <input type='text' autoComplete='off' placeholder='Username'
                        className={`form-control ${errors.username ? 'is-invalid' : ''}`}
                        {...register('username', {
                            required: 'Enter user\'s username',
                            pattern: {
                                value: /^[a-zA-Z0-9]{8,16}$/,
                                message: 'Username must be alpha-numeric with between 8 and 16 characters'
                            }
                        })}
                    />
                    {errors.username && (
                        <div className="invalid-feedback">{errors.username.message}</div>
                    )}

                </Form.Group>
            
            </Col>

            <Col xl={3} lg={4} md={6} sm={12}>

                <Form.Group>

                    <Form.Label htmlFor='username'>Role</Form.Label>
                    <CustomSelect
                        name='role'
                        control={control}
                        placeholder='Role'
                        rules={{ required: 'Select user\'s role'}}
                        options={[
                            {label: 'Administrator', value:'Administrator'},
                            {label: 'Supervisor', value: 'Supervisor'},
                            {label: 'Security Officer', value: 'Security Officer'}
                        ]}
                    />

                </Form.Group>
            
            </Col>

        </Row>

        <Row>

            <Col xl={3} lg={4} md={6} sm={12}>

                <Form.Group>

                    <Form.Label htmlFor='phone'>WhatsApp Number</Form.Label>
                    <input type='text' autoComplete='off' placeholder='WhatsApp Number'
                    className={`form-control ${errors.phone ? 'is-invalid' : ''}`}
                    {...register('phone', {
                        required: 'Enter client WhatsApp number',
                        pattern: {
                            value: /^\+[0-9]\d{1,14}$/,
                            message: 'Phone number must be in international format'
                        }
                    })}
                    />
                    {errors.phone && (
                    <div className="invalid-feedback">{errors.phone.message}</div>
                    )}

                </Form.Group>

            </Col>

        </Row>

        <CustomButton
            isSaving={isSaving}
            title={isSaving ? 'Saving' : 'Save'}
            icon={<FaSave />}
        />

    </Form>
  )
}

export default UserForm